import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import bemClass from './../../utils/bemClass'
import MenuIcon from './MenuIcon'
import MenuPanel from './MenuPanel'

import './Menu.css'

const cn = bemClass('Menu')

class Menu extends PureComponent {
    state = { active: false }

    toggleActive = () => this.setState({ active: !this.state.active })

    render() {
        const { active } = this.state
        const { location } = this.props

        return (
            <div className={cn()}>
                <MenuPanel
                    className={cn('menu-panel')}
                    active={active}
                    location={location.pathname}
                    onChange={this.toggleActive}
                />
                <MenuIcon
                    className={cn('menu-icon')}
                    active={active}
                    onClick={this.toggleActive}
                />
                {/* <Socials className={cn('socials')} /> */}
            </div>
        )
    }
}

Menu.propTypes = {
    location: PropTypes.object,
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx